import config from '../../../config';

export const redirectToBuyFlow = guestTypeUser => {
  const url = guestTypeUser
    ? `${config('clxUrl')}/usis/login/logout?sdurl=${config(
        'clxUrl'
      )}/usis/transactions/buy`
    : `${config('clxUrl')}/usis/transactions/buy`;

  window.open(url, '_blank');

  return url;
};

export const navigateToTrustedContact = () => {
  const url =
    'https://www.troweprice.com/usis/my-accounts/profile/trusted-contacts';
  window.open(url, '_blank');
  return url;
};

export const openMailACheckSlip = checkFormUrl => {
  window.open(checkFormUrl, '_blank');
  return checkFormUrl;
};
